<template>
    <div>
        <b-modal
            id="modify-risk-factor-popup"
            ref="modal"
            :title="titlePopup"
            size="sm"
            no-close-on-backdrop
            no-close-on-esc
            hide-footer
            modal-class="hide-footer"
            :hide-header-close="loading"
            @hidden="onHidden"
        >
            <b-form
                @submit.stop.prevent="onSubmit()"
                @reset.stop.prevent="onHidden"
            >
                <div class="row custom-model-form risk-factor-popup">
                    <div class="col-md-12">
                        <b-form-group
                            id="risk-factor-weight"
                            label="Weight"
                            label-for="Weight"
                        >
                            <b-form-input
                                id="risk-factor-weight-input"
                                v-model="formData.weight"
                                v-validate="{
                                    required: true,
                                    regex: /^([0-9]*)$/,
                                    min: 1,
                                    max: 3,
                                }"
                                type="text"
                                autocomplete="no"
                                placeholder="Enter weight"
                                name="weight"
                                :class="{
                                    'is-invalid': errors.has('weight'),
                                }"
                            ></b-form-input>
                        </b-form-group>
                    </div>
                    <!-- <div class="col-md-12">
                        <b-form-group
                            id="risk-factor-override"
                            label="Override To"
                            label-for="Override To"
                        >
                            <b-form-select
                                id="risk-factor-override-input"
                                v-model="formData.overRideTo"
                                class="form-control"
                                :options="overrideToOptions"
                                name="overrideTo"
                                :class="{
                                    'is-invalid': errors.has('overrideTo'),
                                }"
                            ></b-form-select>
                        </b-form-group>
                    </div> -->
                    <div class="col-md-12 scale-type row-min-space">
                        <h4>Score Scale</h4>
                        <div class="row">
                            <div class="col-md-4">
                                <b-form-group
                                    id="risk-factor-score-high"
                                    class="mb-0"
                                    :label="highLabel"
                                    label-for="High"
                                >
                                    <b-form-input
                                        id="risk-factor-score-high-input"
                                        v-model.number="
                                            formData.scoreScale.high
                                        "
                                        v-validate="{
                                            required: true,
                                            max_value: 1,
                                        }"
                                        type="number"
                                        step="any"
                                        :placeholder="highPlaceholder"
                                        name="scoreScale[high]"
                                        :class="{
                                            'is-invalid': errors.has(
                                                'scoreScale[high]'
                                            ),
                                        }"
                                    ></b-form-input>
                                </b-form-group>
                            </div>
                            <div class="col-md-4">
                                <b-form-group
                                    id="risk-factor-score-medium"
                                    class="mb-0"
                                    :label="mediumLabel"
                                    label-for="Medium"
                                >
                                    <b-form-input
                                        id="risk-factor-score-medium-input"
                                        v-model.number="
                                            formData.scoreScale.medium
                                        "
                                        v-validate="{
                                            required: true,
                                            max_value: 1,
                                        }"
                                        type="number"
                                        step="any"
                                        :placeholder="mediumPlaceholder"
                                        name="scoreScale[medium]"
                                        :class="{
                                            'is-invalid': errors.has(
                                                'scoreScale[medium]'
                                            ),
                                        }"
                                    ></b-form-input>
                                </b-form-group>
                            </div>
                            <div class="col-md-4">
                                <b-form-group
                                    id="risk-factor-score-low"
                                    :label="lowLabel"
                                    label-for="Low"
                                >
                                    <b-form-input
                                        id="risk-factor-score-low-input"
                                        v-model.number="formData.scoreScale.low"
                                        v-validate="{
                                            required: true,
                                            max_value: 1,
                                        }"
                                        type="number"
                                        step="any"
                                        :placeholder="lowPlaceholder"
                                        name="scoreScale[low]"
                                        :class="{
                                            'is-invalid': errors.has(
                                                'scoreScale[low]'
                                            ),
                                        }"
                                    ></b-form-input>
                                </b-form-group>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-12 action-buttons">
                    <base-button
                        :btn-label="buttonLabel"
                        btn-type="submit"
                        btn-variant="primary"
                        :class="loading ? 'disabled' : ''"
                    ></base-button>
                    <base-button
                        btn-label="Cancel"
                        btn-type="reset"
                        btn-variant="link"
                    ></base-button>
                </div>
            </b-form>
        </b-modal>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {
        title: {
            type: String,
            default: null,
        },
    },
    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            formData: this.initializeFormData(),

            high: '',
            low: '',
            medium: '',

            overrideToOptions: [
                { value: null, text: 'Select Override To', disabled: true },
                { value: '', text: 'N/A' },
                { value: 'high', text: 'High Risk' },
                { value: 'medium', text: 'Medium Risk' },
                { value: 'low', text: 'Low Risk' },
                { value: 'sanction', text: 'Sanction Risk' },
            ],
        }
    },
    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters(['loading', 'selectedItem', 'hidePopup']),

        titlePopup() {
            return 'Modify ' + (this.selectedItem ? this.formData.factor : '')
        }, // End of titlePopup() method

        buttonLabel() {
            return this.selectedItem ? 'Update' : 'Create'
        },
        highLabel() {
            return this.formData.factor === 'Assets Under Management' ||
                this.formData.factor === 'Suspicious Activity Reports'
                ? 'Sanction'
                : 'High'
        },
        highPlaceholder() {
            return this.formData.factor === 'Assets Under Management' ||
                this.formData.factor === 'Suspicious Activity Reports'
                ? 'Sanction Scale'
                : 'High Scale'
        },
        lowLabel() {
            return this.formData.factor === 'Assets Under Management' ||
                this.formData.factor === 'Suspicious Activity Reports'
                ? 'Medium'
                : 'Low'
        },
        lowPlaceholder() {
            return this.formData.factor === 'Assets Under Management' ||
                this.formData.factor === 'Suspicious Activity Reports'
                ? 'Medium Scale'
                : 'Low Scale'
        },
        mediumLabel() {
            return this.formData.factor === 'Assets Under Management' ||
                this.formData.factor === 'Suspicious Activity Reports'
                ? 'High'
                : 'Medium'
        },
        mediumPlaceholder() {
            return this.formData.factor === 'Assets Under Management' ||
                this.formData.factor === 'Suspicious Activity Reports'
                ? 'High Scale'
                : 'Medium Scale'
        },
    }, // End of Component > computed
    /*
    |--------------------------------------------------------------------------
    | Component > watch
    |--------------------------------------------------------------------------
    */
    watch: {
        /**
         * Handle when the selected has been updated
         *
         * @return {void}
         */
        selectedItem(value) {
            if (value !== null && value !== undefined) {
                Object.assign(this.formData, JSON.parse(JSON.stringify(value)))
            } else {
                this.onHidden()
            }
        },
        /**
         * Handle when the popup hide
         *
         * @return {void}
         */
        hidePopup(value) {
            if (value) {
                this.onHidden()
            }
        },
    }, // End of Component > watch
    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        initializeFormData() {
            return {
                _id: null,
                factor: '',
                weight: '',
                overRideTo: null,
                scoreScale: {
                    high: '',
                    low: '',
                    medium: '',
                },
            }
        }, // End of initializeFormData() method
        /**
         * Handle when the modal is closed
         *
         * @return {void}
         */
        onHidden() {
            // clear the selected item
            this.$store.commit('clearItem')
            this.$store.commit('onSubmit', null)
            Object.assign(this.formData, this.initializeFormData())
            this.$validator.reset()
            this.$refs.modal.hide()
        }, // End of onHidden() method
        /**
         * Handle when the modal is canceled
         *
         * @return {void}
         */
        async onSubmit() {
            const result = await this.$validator.validateAll()
            if (result) {
                try {
                    await this.$store.dispatch('onSubmit', this.formData)
                } catch (error) {
                    // console.log(error, 'There is an error on submit')
                }
            }
        }, // End of onSubmit() method
    }, // End of Component > methods
}
</script>
